import {
    MJPromotion
} from "../main/promotion3.js";
class Core {
    constructor() {
        this.currentTimeout = null;
    }
    promotion(object) {
        new MJPromotion(object);
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        }
        return new Promise((resolve) => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    }
}
$(window).on("load", function() {
    const dndPromotion = new Core().promotion;
    let globalCount;

    // Object để lưu timeWait động
    const timeWaitConfig = { value: 2000 };

    async function animationRandom(count, elementResult) {
        const listItem = $(".effect__item");
        const itemCount = listItem.length;
        const roundNumber = Math.floor(count / itemCount);
        const sequenceNumber = count % itemCount;

        // Chạy theo thứ tự
        listItem.removeClass("active");
        const target = $(listItem[sequenceNumber]);
        target.addClass("active");

        await new Core().wait(100);

        // Round 1: chạy hết vòng
        if (roundNumber === 0) {
            animationRandom(count + 1, elementResult);
            return;
        }

        // Round 2: kiểm tra nếu gặp item trúng thì dừng
        // elementResult là 1-based, sequenceNumber là 0-based
        if (roundNumber === 1 && (sequenceNumber + 1) == elementResult) {
            return; // Dừng animation
        }

        // Dừng an toàn nếu vượt quá round 2
        if (roundNumber > 1) {
            return;
        }

        // Nếu chưa trúng, tiếp tục round 2
        animationRandom(count + 1, elementResult);
    }

    dndPromotion({
        url: prodTemplate.url,
        debug: prodTemplate.debug,
        directory: prodTemplate.directory,
        items: prodTemplate.items,
        names: prodTemplate.names,
        config: {
            get timeWait() {
                // Dùng getter để đọc giá trị động
                return timeWaitConfig.value;
            }
        },
        animResult: function(listPrize) {
            var displayPrize = listPrize[0];
            var prizeIndex = parseInt(displayPrize.indexImg); // Convert string to number

            // Tính timeWait chính xác = 1 round + tới prizeIndex ở round 2
            const itemCount = $(".effect__item").length;
            const calculatedTimeWait = (itemCount + prizeIndex) * 100;

            // Cập nhật timeWaitConfig object
            timeWaitConfig.value = calculatedTimeWait;

            animationRandom(0, prizeIndex);
        },
        callback: function() {
            // Xóa active effect__item sau khi popup mở
            setTimeout(() => {
                $(".effect__item").removeClass("active");
                if (typeof prodTemplate.fnPromotion === "function")
                    prodTemplate.fnPromotion();
                globalCount = 10;
            }, 100);
        },
    });
});